import React from "react";
import { connect } from "react-redux";

import { isSchoolsReady, getSchoolList } from "state/school_money/selectors";

import Spinner from "components/Spinner";
import SchoolLogo from "components/school_money/SchoolLogo";
import SchoolInfo from "components/app/info/SchoolInfo";

class SchoolMoneySchoolList extends React.Component {
  
  render() {
    
    if (!this.props.isReady) {
      return (
        <div className="school-list__placeholder">
          <Spinner size="standalone" color="school_money" />
        </div>
      )
    }
    
    return this.props.schoolList.map(school => {
      const { id, name, websiteURL, phoneNumber, emailAddress } = school.toObject();
      const logo = <SchoolLogo school={school} cssBlockName="school-info" />;
      const props = { name, websiteURL, phoneNumber, emailAddress, logo };
      return (
        <SchoolInfo key={id} product="school_money" {...props} />
      )
    })
    
  }
  
}

export default connect(
  state => ({
    schoolList: getSchoolList(state),
    isReady: isSchoolsReady(state)
  })
)(SchoolMoneySchoolList);



// WEBPACK FOOTER //
// ./src/components/app/info/SchoolMoneySchoolList.js